<template>
	<div class="usp-page customer">
		<main>
			<b-container>
				<div class="parts">
					<div class="part">
						<b-row>
							<b-col lg="6">
								<h1>Top-Bewerber finden!</h1>
								<h2>Wie bei einer Dating-Plattform</h2>
								<CheckboxList
									type="positive"
									:items="[
										{ text: 'Pool mit registrierten Bewerbern' },
										{ text: 'Automatische Bewerber-Vorauswahl' },
										{ text: 'Rangliste der Top-Bewerber (Eignung)' },
										{ text: 'Kosten nur bei Erstkontakt' },
									]"
								/>
							</b-col>
							<b-col offset-lg="1" lg="5">
								<div class="best-match-system">
									<h2>Best-Match-System</h2>
									<h3>Wie gut passt der Bewerber?</h3>
									<img src="/img/customer/usp/best-match-system.png" alt="Best-Match-System"/>
									<div class="best-match-system--avatar">
										<Avatar :avatar="avatarCatNotebook"/>
									</div>
								</div>
							</b-col>
						</b-row>
						<ButtonLine middle-text="skilldoo Job-Matching Plattform" class="mt-3 mt-ld-5"/>
					</div>
					<div class="part">
						<h2 class="big">Nur 3 Schritte zum Top-Bewerber!</h2>
						<div :class="['how-it-works', 'how-it-works--full', 'how-it-works--center']">
							<div class="how-it-works--items">
								<div
									v-for="(item, i) in threeStepsItems"
									:class="{'how-it-works--item': true, 'how-it-works--item-non-free': item.free === false}"
								>
									<div class="how-it-works--item-number">
										<span>{{ i + 1 }}</span>
									</div>
									<div v-if="item.free !== undefined" class="how-it-works--item-free-info">
										<span>{{ item.free ? 'Gratis' : 'Faire Preise' }}</span>
									</div>
									<div class="how-it-works--item-title">{{ item.title }}</div>
									<div class="how-it-works--item-sub-title">{{ item.subTitle }}</div>
									<div class="how-it-works--item-image">
										<img :src="item.image" :alt="item.imageAlt"/>
									</div>
								</div>
							</div>
						</div>
						<ButtonLine middle-text="Zeit und Kosten sparen" class="mt-4"/>
					</div>
					<div class="part">
						<h2 class="big">Das Preismodell</h2>
						<h3>
							Kosten nur bei Erstkontakt!<br/>
							Sämtlicher Nachrichtenaustausch nach einem Erstkontakt ist nicht kostenpflichtig!
						</h3>
						<PriceTable/>
						<ButtonLine middle-text="Keine Kreditkarte/Zahlung vor Erstkontakt!" class="mt-4"/>
					</div>
					<div class="part top">
						<h2 class="big">Top für Sie!</h2>
						<b-row>
							<b-col lg="4">
								<CheckboxList
									type="positive"
									:items="[
										{ text: 'Nur geeignete Top-Bewerber'},
										{ text: 'Zeit- und Kostenersparnis'},
										{ text: 'Direktkontakt zu Bewerbern'},
										{ text: 'Zusagen und Absagen erteilen'},
									]"
								/>
							</b-col>
							<b-col lg="4" class="mt-4 mt-md-0">
								<CheckboxList
									type="negative"
									:items="[
										{ text: 'Keine Vermittlungsprovision'},
										{ text: 'Keine Inserate texten/gestalten'},
										{ text: 'Keine Inseratekosten'},
										{ text: 'Kein Auswahlstress'},
									]"
								/>
							</b-col>
							<b-col lg="4">
								<div class="top-avatar-container">
									<Avatar :avatar="avatarHoldingNothing"/>
								</div>
							</b-col>
						</b-row>
						<ButtonLine middle-text="Kosten nur bei Erstkontakt!"/>
					</div>
				</div>
			</b-container>
		</main>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import Avatar, {CAT_NOTEBOOK, HOLDING_NOTHING} from "@/vue/common/image/Avatar.vue";
import Feature from "@/vue/homepage/Feature.vue";
import HowItWorks from "@/vue/info/HowItWorks.vue";
import CustomerBenefits from "@/vue/info/CustomerBenefits.vue";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import CheckboxList from "@/vue/common/CheckboxList.vue";
import ButtonLine from "@/vue/customer/ButtonLine.vue";
import Icon from "@/vue/icon/Icon.vue";
import PriceTable from "@/vue/payment/PriceTable.vue";

const THREE_STEPS_ITEMS = [
	{
		title: 'Profil',
		subTitle: 'Registrierte Bewerber',
		free: true,
		image: '/img/customer/usp/ueberschneidung.png',
		imageAlt: 'Grafik mit Überschneidung von Jobs und Bewerbern',
	},
	{
		title: 'Auswahl',
		subTitle: 'Best-Match-System',
		free: true,
		image: '/img/customer/usp/matching.png',
		imageAlt: 'Balkenansicht eines Job-Matchings',
	},
	{
		title: 'Direktkontakt',
		subTitle: 'Zusagen und Absagen',
		free: false,
		image: '/img/customer/usp/kontaktsystem.png',
		imageAlt: 'Visualisierung des Kontaktsystems',
	},
];

export default {

	components: {
		PriceTable,
		Icon,
		ButtonLine,
		CheckboxList,
		CustomerBenefits,
		HowItWorks,
		Feature,
		Avatar,
		Button,
	},

	mounted ()
	{
		Event.push(
			new EventData()
				.setEvent(Event.PAGE_VISIT)
				.setAction('Mitarbeiter finden = Kunden-Startseite')
		);
	},

	computed: {
		avatarCatNotebook ()
		{
			return CAT_NOTEBOOK;
		},
		avatarHoldingNothing ()
		{
			return HOLDING_NOTHING;
		},
		threeStepsItems ()
		{
			return THREE_STEPS_ITEMS
		}
	}
}
</script>
